export interface DevModeTestUser {
    label: string;
    firstName?: string;
    lastName?: string;
    ssn?: string;
    url?: string;
    hasNoBAN?: boolean; // Indicates that the buffer response will not contain BAN/account data, and person data is at the root level
    customerType: "existing" | "new";
}

export const DEV_MODE_TEST_USERS: DevModeTestUser[] = [
    {
        label: "Existing with single BAN (Karolina, 1 sub)",
        firstName: "Karolina",
        lastName: "Khan",
        ssn: "06087111081",
        customerType: "existing",
    },
    {
        label: "Existing with multiple BAN",
        firstName: "Bent",
        lastName: "Bendiksen",
        ssn: "31086812900",
        customerType: "existing",
    },
    {
        label: "From buffer: Existing (5GB without commitment)",
        url: "https://jcore-tools.telia.no/component/test-reporting/ta/reporting/buffertypes/33/item",
        customerType: "existing",
    },
    {
        label: "From buffer: Existing (5GB with commitment)",
        url: "https://jcore-tools.telia.no/component/test-reporting/ta/reporting/buffertypes/32/item",
        customerType: "existing",
    },
    {
        label: "From buffer: New",
        url: "https://jcore-tools.telia.no/component/test-reporting/ta/reporting/buffertypes/23/item",
        hasNoBAN: true,
        customerType: "new",
    },
];
